import React, { useContext } from 'react'
import { H1, H2, P } from '@jarvis.oddle/core/components/Typo'
import Card from '@jarvis.oddle/core/components/Card'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import useAppSelector from 'src/hooks/useAppSelector'
import ResponsiveSection from 'src/components/core/ResponsiveSection'
import { selectAllPromotions } from 'src/redux/promotion'

const Promotions = (): JSX.Element => {
  const promotions: Promotion[] = useAppSelector(selectAllPromotions).data
  const { t } = useContext(TranslationContext)
  return (
    <ResponsiveSection>
      <ResponsiveSection.Container>
        <H1 sectionHeading>{t('Promotions')}</H1>
        {promotions.map(({ name, description, endDate, endTime }) => (
          <Card key={name} marginBottom='small'>
            <H2 bold>{name}</H2>
            <P>{description}</P>
            {endDate && (
              <P>
                {t(`Valid until _endDate_ _endTime_`, {
                  endDate: endDate,
                  endTime: endTime || ''
                })}
              </P>
            )}
          </Card>
        ))}
      </ResponsiveSection.Container>
    </ResponsiveSection>
  )
}

export default Promotions
